import { useCustom, useNavigation } from "@refinedev/core";
import { CreateButton, List } from "@refinedev/antd";
import { Button, Space, Table, Tag } from "antd";
import { useState } from "react";
import { apiUrl } from "@/consts";

type ScoutingEvent = {
  id: string;
  title: string;
  location: string;
  startTime: string;
  status: "DRAFT" | "ACTIVE" | "COMPLETED" | "CANCELLED";
};

const STATUS_COLOR: Record<string, string> = {
  DRAFT: "default",
  ACTIVE: "success",
  COMPLETED: "blue",
  CANCELLED: "red",
};

const PAGE_SIZE = 20;

export function ScoutingEventList() {
  const { show, create, edit } = useNavigation();
  const [page, setPage] = useState(1);

  const { data, isLoading, isFetching } = useCustom<{ events: ScoutingEvent[]; total: number }>({
    url: `${apiUrl}/scouting-event`,
    method: "get",
    config: { query: { page: String(page), limit: String(PAGE_SIZE) } },
  });

  const events = data?.data?.events ?? [];
  const total = data?.data?.total ?? 0;

  return (
    <List
      headerButtons={
        <CreateButton onClick={() => create("scouting-event")} />
      }
    >
      <Table
        loading={isLoading || isFetching}
        dataSource={events}
        rowKey="id"
        pagination={{
          current: page,
          pageSize: PAGE_SIZE,
          total,
          showTotal: (t) => `${t} events`,
          onChange: (p) => setPage(p),
          showSizeChanger: false,
        }}
        columns={[
          {
            title: "Title",
            dataIndex: "title",
          },
          {
            title: "Location",
            dataIndex: "location",
          },
          {
            title: "Start Time",
            dataIndex: "startTime",
            render: (v: string) => new Date(v).toLocaleString(),
          },
          {
            title: "Status",
            dataIndex: "status",
            render: (v: string) => (
              <Tag color={STATUS_COLOR[v] ?? "default"}>{v}</Tag>
            ),
          },
          {
            title: "Actions",
            render: (_: any, record: ScoutingEvent) => (
              <Space>
                <Button
                  size="small"
                  onClick={() => show("scouting-event", record.id)}
                >
                  Manage
                </Button>
                <Button
                  size="small"
                  onClick={() => edit("scouting-event", record.id)}
                >
                  Edit
                </Button>
              </Space>
            ),
          },
        ]}
      />
    </List>
  );
}
